<template>
	<div>
		<div class="header">
			<div class="elHeaderchild">
				<home-top></home-top>
			</div>
			<!-- 轮播图 -->
			<div class="rotationFrame">
				<swiper class="sAstyle" :swiperSetting="swiperSetting" :slideArray="slideArray"></swiper>
				<!-- 遮罩层 -->
				<div class="rotationMask">
					<span>{{ rotationFont }}</span>
				</div>
				<!-- 图形 -->
				<div class="graphicalFont">
					<div>
						<span>HOME</span>
					</div>
					<div class="p-marginLeft10">
						<span>——</span>
					</div>
				</div>
				<!-- 标题文字 -->
				<div class="rotationFontFrame">
					<div class="rotationChildFontFrame">
						<div class="rotationFontFrameFont">
							<span>企业新闻动态</span>
						</div>
						<div class="rotationFontFrameFont1">
							<span>ENTERPRISE NEWS TRENDS</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="mainChild">
			<div class="mainChildTop">
				<div class="mainChildTopChild">
					<div :class="changeBoolean ? 'mainChildTopChild2' : 'mainChildTopChild22'" @click="changeThis(2)">
						<span>政府关联新闻</span>
					</div>
					<div :class="changeBoolean ? 'mainChildTopChild1' : 'mainChildTopChild11'" @click="changeThis(1)">
						<span>企业重大事件新闻</span>
					</div>
				</div>
			</div>
			<div class="mainChildContent">
				<div class="mainChildContent1" v-for="(item, index) in mainChildArray" :key="index">
					<div class="mainChildImg">
						<img :src="item.articlePicture" class="p-imgStyle" />
					</div>
					<div class="mainChildContentChild">
						<div class="mainChildContentFont">
							<div class="mainChildContentFont1">
								<span>{{ item.articleTitle }}</span>
							</div>
							<!-- <div class="mainChildContentFont2">
                                    <span>{{ item.date }}</span>
                                </div>
                                <div class="mainChildContentFont3">
                                    <span>{{ item.content }}</span>
                                </div> -->
						</div>
						<div class="p-marginTop30">
							<el-button round class="mainChildContent1Button" @click="readOn(item.articleDetail)">
								继续阅读
							</el-button>
						</div>
					</div>
				</div>
				<div class="mainChildContentFooter"></div>
				
			</div>
		</div>

		<div class="elFooter">
			<home-bottom></home-bottom>
		</div>
	</div>
</template>

<script>
	import swiper from "../assembly/swiper.vue"
	import homeTop from '../assembly/homeTop.vue'
	import homeBottom from '../assembly/homeBottom.vue'
	import {
		getArticleList
	} from "../api/home.js"
	export default {
		data() {
			return {
				swiperSetting: {
					delay: 3000
				},
				slideArray: [{
					url: require("@/assets/bg2.png")
				}, ],
				rotationFont: "公司公告: 山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名",
				mainChildArray: [],
				changeBoolean: false
			}
		},
		components: {
			homeTop,
			swiper,
			homeBottom
		},
		methods: {
			// 继续阅读
			readOn(connect) {
				if (connect !== "") {
					window.location.href = connect
				}
			},
			// 点击事件
			changeThis(num) {
				this.changeBoolean = !this.changeBoolean
				var param = 0;
				if (!this.changeBoolean) {
					param = 1;
				}
				getArticleList({
					articleType: param
				}).then((res) => {
					console.log(res.data)
					// 赋值
					this.mainChildArray = res.data
				})
			}
		},
		created() {
			let param = 1
			getArticleList({
				articleType: param
			}).then((res) => {
				console.log(res.data)
				// 赋值
				this.mainChildArray = res.data
			})
		}
	}
</script>

<style scoped lang="scss">
	.header {
		position: absolute;
		height: 100%;
		width: 100%;
	}

	.elHeaderchild {
		height: 6%;
	}

	.rotationFrame {
		height: 94%;


		.rotationMask {
			top: 92%;
			height: 4rem;
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: absolute;
			z-index: 3;
			color: #fff;
			background: rgba(0, 0, 0, 0.5);
			font-size: 1.5rem;
		}

		//    轮播图
		.sAstyle {
			height: 100%;
			width: 100%;
			margin-left: auto;
			margin-right: auto;
			position: relative;
			overflow: hidden;
			z-index: 1;
		}

		// 标题文字
		.rotationFontFrame {
			z-index: 3;
			height: 15%;
			width: 100%;
			top: 40%;
			position: absolute;
			color: #fff;
			pointer-events: none;
			display: flex;
			justify-content: center;

			.rotationChildFontFrame {
				display: flex;
				flex-direction: column;
				width: 40%;
			}

			.rotationFontFrameFont {
				font-size: 4.8rem;
				letter-spacing: 30px;
			}

			.rotationFontFrameFont1 {
				display: flex;
				justify-content: flex-end;
				font-size: 2.4rem
			}
		}
	}

	// 输入框
	/deep/ .el-input__inner {
		background-color: #BBBBBB;
	}

	// 字体
	.graphicalFont {
		position: absolute;
		display: flex;
		z-index: 2;
		top: 51.5%;
		width: 50%;
		color: #fff;
		justify-content: end;
		align-items: center;
		margin-left: 46%;
	}


	.mainChild {
		top: 100%;
		height: 100%;
		width: 100%;
		position: absolute;
		display: flex;
		flex-direction: column;
		align-items: center;

		// 企业新闻, 政府关联新闻, 切换事件
		.mainChildTop {
			width: 60%;
			display: flex;
			justify-content: center;

			.mainChildTopChild {
				display: flex;
				width: 100%;
				cursor: pointer;
				border: solid 1px;
				font-size: 2rem;
				letter-spacing: 1px;

				.mainChildTopChild1 {
					padding: 2rem;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 50%;
					background-color: #840000;
					color: #fff;
				}

				.mainChildTopChild11 {
					padding: 2rem;
					color: #840000;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 50%;
				}

				.mainChildTopChild2 {
					padding: 2rem;
					color: #840000;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 50%;
				}

				.mainChildTopChild22 {
					padding: 2rem;
					display: flex;
					justify-content: center;
					align-items: center;
					width: 50%;
					background-color: #840000;
					color: #fff;
				}
			}
		}

		// 主体介绍
		.mainChildContent {
			margin-top: 7%;
			position: absolute;
			overflow-y: scroll; //滚动条
			height: 100%;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			.mainChildContent1 {
				margin: 5rem 0 35rem 0;
				height: 80vh;
				display: flex;
				border-top: solid 2px #BBBBBB;
				width: 60%;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				.mainChildImg {
					width: 100%;
				}

				.mainChildContentChild {
					width: 100%;

					.mainChildContentFont {
						display: flex;
						flex-direction: column;

						.mainChildContentFont1 {
							margin-top: 50px;
							font-size: 2rem;
							letter-spacing: 1px;
							color: #7B0000;
						}

						.mainChildContentFont2 {
							margin-top: 40px;
							font-size: 10px;
							letter-spacing: 1px;
						}

						.mainChildContentFont3 {
							margin-top: 40px;
							font-size: 0.8rem;
							letter-spacing: 1px;
						}
					}

					.mainChildContent1Button {
						color: #fff;
						background-color: #840000;
						height: 4rem;
						width: 14rem;
						font-size: 0.8rem;
					}
				}
			}

			.mainChildContentFooter {
				margin-top: 20px;
				display: flex;
				width: 100%;
				height: 30rem;
				background-color: #840000;
			}
		}
	}

	// 底部
	.elFooter {
		top: 200%;
		height: 300px;
		width: 100%;
		position: absolute;
	}
</style>


// WEBPACK FOOTER //
// src/components/news.vue